(() => {
  'use strict';
  if (window.mxwKeycapsNavigation) return;
  const selector = 'details[data-mx-keycaps]';
  const mobile = matchMedia('(max-width:767px)');
  const closeKeycaps = (except) => document.querySelectorAll(`${selector}[open]`).forEach(menu => {
    if (menu !== except) menu.open = false;
  });
  function closeLegacy(nav) {
    nav.classList.remove('is-open');
    nav.querySelector('[data-mx-legacy-toggle]')?.setAttribute('aria-expanded', 'false');
  }
  function alignPopover(details) {
    const menu = details.querySelector('.mxw-keycaps-menu');
    if (!menu || details.closest('.mobile-menu') || (mobile.matches && details.closest('.mxw-legacy-links'))) return;
    menu.style.removeProperty('--mxw-dropdown-shift');
    const rect = menu.getBoundingClientRect();
    const scale = rect.width / menu.offsetWidth || 1;
    const shift = Math.min(0, innerWidth - 12 - rect.right) + Math.max(0, 12 - rect.left);
    menu.style.setProperty('--mxw-dropdown-shift', `${shift / scale}px`);
  }
  document.addEventListener('toggle', event => {
    const details = event.target;
    if (!details.matches?.(selector) || !details.open) return;
    closeKeycaps(details);
    requestAnimationFrame(() => alignPopover(details));
  }, true);
  document.addEventListener('click', event => {
    document.querySelectorAll(`${selector}[open]`).forEach(menu => {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
    const toggle = event.target.closest('[data-mx-legacy-toggle]');
    if (toggle) {
      const nav = toggle.closest('.mxw-legacy-nav');
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      if (!open) closeKeycaps();
    }
    document.querySelectorAll('.mxw-legacy-nav.is-open').forEach(nav => {
      if (!nav.contains(event.target) || event.target.closest('a')) closeLegacy(nav);
    });
    if (event.target.closest('.menu-toggle')) closeKeycaps();
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector(`${selector}[open]`);
    const legacy = document.querySelector('.mxw-legacy-nav.is-open');
    closeKeycaps();
    if (legacy) {
      closeLegacy(legacy);
      legacy.querySelector('[data-mx-legacy-toggle]')?.focus();
    } else if (open) {
      const outer = open.closest('.mobile-menu');
      (outer?.hidden ? outer.closest('#header')?.querySelector('.menu-toggle') : open.querySelector('summary'))?.focus();
    }
  });
  mobile.addEventListener('change', () => {
    closeKeycaps();
    document.querySelectorAll('.mxw-legacy-nav').forEach(closeLegacy);
    document.querySelectorAll('.mobile-menu').forEach(menu => { menu.hidden = true; });
    document.querySelectorAll('.menu-toggle').forEach(toggle => toggle.setAttribute('aria-expanded', 'false'));
  });
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(selector).forEach(menu => { menu.open = false; });
  });
  document.documentElement.classList.add('mxw-navigation-ready');
  window.mxwKeycapsNavigation = {close: closeKeycaps};
})();
